<template>
    <div class="schoolBox">
        <!-- 标题 -->
        <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
        <!-- 搜索框 -->
        <div class="searchCon">
          <div class="searchMain">
            <ots-refer :selectList="selectList" :request-form="selectForm" @search="getResult"/>
          </div>
        </div>
        <!-- 列表 -->
        <div class="mainCon">
          <ots-table-group
            :tableHeader="tableHeader"
            :tableOption="tableOption"
            :tableData="tableData"
            :batchOperBtn="batchOperBtn"
            @handleSelectionChange="bachOper"
            :pagination="pagination"
            @changeNum="changeSize"
            @changePage="changePage"
          ></ots-table-group>
        </div>
        <!-- 弹窗 -->
        <ots-custom-dialog :dialog.sync="addDialog" :title="form.code?'修改':'添加学校'" width="40%">
          <template v-slot:content>
            <div>
              <el-form ref="form" :model="form" :rules="rules">
                <el-form-item label="学校名称" class="childrenName" prop="name">
                  <el-input v-model.trim="form.name" placeholder="请输入"></el-input>
                  <el-checkbox v-model="form.form_isMain" class="ml20">本校</el-checkbox>
                  <el-tooltip content="本校为负责组织考试的学校" placement="top">
                    <i class="el-icon-warning ml10 tipIcon"></i>
                  </el-tooltip>
                </el-form-item>
              <el-form-item label="启用状态">
                  <el-radio-group v-model="form.state">
                      <el-radio-button label=1>启用</el-radio-button>
                      <el-radio-button label=0>停用</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-form>
            </div>
          </template>
          <template v-slot:footer>
            <el-button round @click="addDialog=false">取消</el-button>
            <el-button round type="primary" @click="addSchool">确定</el-button>
          </template>
        </ots-custom-dialog>
    </div>
</template>
<script>
import { getAllSchool, addSchoolFn, updateSchoolFn, deleteSchoolFn, updateSchoolStateFn } from '@/http/modules/baseSet/school'
import { mapActions } from 'vuex'
export default {
  name: 'school',
  data () {
    return {
      /* ** 院校信息是否存储 vuex ** */
      updataSelectSchoolFlag: false,
      /* ** 勾选院校Id集合 ** */
      selectIds: [],
      /* ** 搜索表单配置 ** */
      selectList: [
        {
          title: "状态",
          type: "select",
          requestKey: "state",
          label: 'key',
          value: 'value',
          data: [
            { key : '全部', value : -1 },
            { key : '启用', value : 1 },
            { key : '停用', value : 0 }
          ],
        },
        {
          title : '学校名称',
          type : 'input',
          placeholder : '请输入学校名称',
          requestKey: "searchKey"
        }
      ],
      /* ** 搜索数据 ** */
      selectForm: {
        state : -1,
        searchKey : '',
      },
      /* ** 表格头 ** */
      tableHeader: [
        {
          title: "学校名称",
          prop: "name"
        },
        {
          title: "是否本校",
          prop: "isMain",
          formatter: (val) => val.row.isMain == 1 ? '是' : '否',
        },
        {
          prop: 'stationCount',
          title: '教学点',
          type: "button",
          click: this.goStationPage,
          disableFn: (scope) => {
            return scope.row.stationCount == 0;
          },
        },
        {
          title:"启用状态",
          prop:"state",
          type:"switch",
          switchChange:this.changeSchoolState
        },
        {
          title:"操作",
          type:"buttons",
          width:"100",
          btnList:[
            { title:"编辑", click: this.editSchool },
            { title:"删除", click: this.deleteSchool },
          ]
        }
      ],
      /* ** 开启表格勾选 ** */
      tableOption: {
          multiple: true
      },
      /* ** 表格 -- 左上按钮 ** */
      batchOperBtn:[
        {
          title: "删除",
          icon: "iconfont icon-shanchu",
          click: this.deleteSchool
        },
      ],

      /* ** 表格数据 ** */
      tableData: [],
      /* ** 新增/编辑 -- 表单数据 ** */
      form: {
        name: '',
        state: 1,
        form_isMain: false,
      },
      /* ** 新增/编辑 表单校验规则 ** */
      rules: {
        name: [
          { required: true, message: '请输入学校名称', trigger: 'blur'},
          { min: 1, max: 30, message: '输入范围在 1 到 30 个字符', trigger: 'blur' }
        ]
      },
      /* ** 新增按钮 ** */
      mainTopBtnList: [
        {
          title: '新增',
          fn: this.addSchoolDialog
        }
      ],
      /* ** 新增/编辑 弹窗 ** */
      addDialog: false,
      /* ** 分页 -- 总数 ** */
      pagination: {
        total: 0
      },
      /* ** 分页组件配置数据 ** */
      schoolListParams: {
        orders: 'createDate desc',
        page: 1,
        size: 10
      }
    }
  },
  created () {
    this.getAllSchoolFn()
  },
  beforeDestroy () {
    /* ** 存储院校信息 ** */
    if (this.updataSelectSchoolFlag) {
      this.getSelectSchoolAction()
    }
  },
  methods: {
    ...mapActions('selectOptions', ['getSelectSchoolAction']),

    /********************************* 
     * @bachOper 勾选课程Id拼接
     *********************************/
    bachOper (val) {
      let idList=[]
      val.forEach(item=>{ idList.push(item.id) })
      this.selectIds = idList
    },

    /********************************* 
     * @addSchoolDialog 新增:开启弹窗
     *********************************/
    addSchoolDialog () {
      this.resetForm()
      this.addDialog = true
    },

    /********************************* 
     * @addSchool 执行 添加/编辑 操作
     *********************************/
    addSchool () {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          // (1) 添加/编辑 是否勾选 "本校"
          this.form.isMain = this.form.form_isMain ? 1 : 0
          // (2) 添加/编辑 表单参数
          let params = {...this.form}
          // (3) 删除以 "form_" 开头的参数
          for (let key in params) {
            if (key.startsWith('form_')) { delete params[key] }
          }
          // (4) 添加 ? 修改 ?
          const useFn = params.id ? updateSchoolFn : addSchoolFn
          // (5) 调用 添加/修改 接口
          const { code } = await useFn(params)
          if (code ==  1) {
            this.$message.success('操作成功')
            this.updataSelectSchoolFlag = true
            // (6) 关闭弹窗: 重置表单参数, 重新查询表格数据
            this.addAfter()
          }
        } else {
          return false
        }
      })
    },

    /*********************************
     * @editSchool 编辑课程
     *********************************/
    editSchool (row) {
      this.form = Object.assign(this.form, row)
      this.form.form_isMain = row.isMain == 0 ? false : true
      this.addDialog = true
    },

    /*********************************
     * @beforeBatch 院校勾选
     *********************************/
    beforeBatch () {
      if (this.selectIds.length > 0) {
        return true
      } else {
        this.$message.warning('请先选择学校')
        return false
      }
    },

    /*********************************
     * @deleteSchool 删除院校
     *********************************/
    deleteSchool (row) {
      // (1) 是否勾选了院校
      if (!(row || this.beforeBatch())) {
        return false
      }
      // (2) 删除参数
      let param = {
        ids: row ? row.id : this.selectIds.join()
      }
      // (3) 删除确认弹窗
      this.$confirm('确定删除该学校?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const { code } = await deleteSchoolFn(param)
          if (code == 1) {
            this.$message.success('删除成功')
            this.updataSelectSchoolFlag = true
            this.getAllSchoolFn()
          }
        })
    },

    /*********************************
     * @changeSchoolState 修改启用状态
     *********************************/
    async changeSchoolState (row) {
      let param = { id: row.id, state: row.state }
      const { code } = await updateSchoolStateFn(param)
      if (code == 1) {
        this.$message.success('修改成功')
        this.updataSelectSchoolFlag = true
      }else{
        row.state = 1;
      }
    },

    /*********************************
     * @getAllSchoolFn 获取院校数据
     *********************************/
    async getAllSchoolFn () {
      this.schoolListParams = Object.assign(this.schoolListParams, this.selectForm)
      const { data } = await getAllSchool(this.schoolListParams)
      this.tableData = data.records
      this.pagination.total = data.total
    },

    /*********************************
     * @resetForm 新增/编辑 表单重置
     *********************************/
    resetForm() {
      this.form = {
        name: '',
        state: 1,
        form_isMain: false,
      }
    },

    /*********************************
     * @getResult 搜索按钮
     *********************************/
    getResult () {
      this.schoolListParams.page = 1
      this.getAllSchoolFn()
    },

    /*********************************
     * @addAfter 新增/编辑操作后,重置
     *********************************/
    addAfter () {
      this.addDialog = false
      this.resetForm()
      this.getAllSchoolFn()
    },

    /* *** 分页组件相关 *** */
    changeSize(num) {
        this.schoolListParams.size=num
        this.getAllSchoolFn()
    },

    /* *** 分页组件相关 *** */
    changePage(p) {
        this.schoolListParams.page=p
        this.getAllSchoolFn()
    },

    goStationPage(row){
      if(row.stationCount > 0){
        this.$router.push({
          path: "station",
          query: { searchId: row.id },
        });
      }else{
        return false;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.schoolBox {
  .searchCon {
    background-color: #fff;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    .searchMain {
      flex: 1;
    }
    .searchBtn {
      flex-shrink: 0;
      width: 72px;
      height: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .mainCon {
    padding: 20px;
    border-radius: 8px;
    background-color: #fff;
  }
}
.tipIcon{
    position: relative;
    .tips {
      font-size: 13px;
      position: absolute;
      color: #fff;
      width: 176px;
      text-align: center;
      padding: 10px;
      top: -48px;
      left: -90px;
      background: rgba(0, 0, 0, 0.85);
    }
    .tips::after{
      content: '';
      border: 5px solid transparent;
      border-top-color: rgba(0, 0, 0, 0.85);
      position: absolute;
      top: 33px;
      left: 96px;
    }
}
</style>
